import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeletePostTagMutation = createMutationHook(
  MembershipsCreatorApiClient.deletePostTag,
  {
    mutationKey: ['deletePostTag'],
  },
)
